/**
 * gameIcons — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const gameIconsPack: ToilePack = {
    slug: 'game-icons',
    category: 'gameicons',
    name: 'Game icons',
    tagline: tagline('sheets', 'item sets', 'styles'),
    chips: chips('item sets', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'potions', label: 'Potions', subject: 'health, mana, poison, elixir, philtre and draught bottles'},
        {key: 'weapons', label: 'Weapons', subject: 'a broadsword, a battle axe, a war hammer, a dagger, a bow and a staff'},
        {key: 'runes', label: 'Spell runes', subject: 'carved discs and sigils for fire, frost, storm, life and shadow'},
    ],
    styles: [
        {key: 'painterly', label: 'Painterly', style: 'hand-painted RPG rendering, visible brush strokes', palette: 'rich saturated color, soft rim light', framing: 'three-by-three icon grid, plain ground'},
        {key: 'flat', label: 'Flat', style: 'flat stylized vector, bold shapes, no outlines', palette: 'a five-color limited palette', framing: 'three-by-three icon grid, plain ground'},
        {key: 'engraved', label: 'Engraved', style: 'bestiary-plate ink hatching', palette: 'sepia ink on parchment, no fills', framing: 'three-by-three icon grid, plain ground'},
    ],
    directions: ['armor pieces instead', 'in cold blue and steel', 'simpler, readable when small'],
}
